import { useCallback } from 'react'

import useBackgroundService from '@web/hooks/useBackgroundService'
import useQrHardwareControllerState from '@web/hooks/useQrHardwareControllerState'

const useQrSigningFlow = () => {
  const { currentRequest, signingStep } = useQrHardwareControllerState()
  const { dispatch } = useBackgroundService()

  const moveToResponseScan = useCallback(() => {
    dispatch({ type: 'QR_HARDWARE_CONTROLLER_MOVE_TO_RESPONSE_SCAN' })
  }, [dispatch])

  const moveBack = useCallback(() => {
    dispatch({ type: 'QR_HARDWARE_CONTROLLER_MOVE_BACK' })
  }, [dispatch])

  const submitSignatureResponse = useCallback(
    (payload: string | Uint8Array) => {
      dispatch({
        type: 'QR_HARDWARE_CONTROLLER_SUBMIT_SIGNATURE_RESPONSE',
        params: { payload }
      })
    },
    [dispatch]
  )

  const signingCleanup = useCallback(() => {
    dispatch({ type: 'QR_HARDWARE_CONTROLLER_SIGNING_CLEANUP' })
  }, [dispatch])

  return {
    currentRequest,
    signingStep,
    moveToResponseScan,
    moveBack,
    submitSignatureResponse,
    signingCleanup
  }
}

export default useQrSigningFlow
